<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
let mapScriptPromise = null;

function loadTencentMapScript(key) {
  if (window.qq && window.qq.maps) {
    return Promise.resolve(window.qq.maps);
  }
  if (mapScriptPromise) {
    return mapScriptPromise;
  }
  mapScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://map.qq.com/api/js?v=2.exp&key=${key}&callback=initTencentMap`;
    script.onload = () => resolve(window.qq.maps);
    script.onerror = reject;
    document.body.appendChild(script);
  });
  return mapScriptPromise;
}

export default {
  data() {
    return {};
  },
  created() {
    const key = "NAEBZ-LGZCB-EG5US-JLVOC-4FPYH-YZFEW";
    loadTencentMapScript(key);

    window.initTencentMap = () => {
      // window.qq = qq;
      console.log("initTencentMap", window.qq);
    };

    window.requestLogin = () => {
      console.log("requestLogin");
      this.$yd.storage.del("_stoken");
      this.$message({
        message: "登录过期，请重新登录",
        type: "warning",
      });
      this.$router.push({
        path: "/login",
      });
      // this.$bus.$emit("windowScroll", window.scrollY);
    };

    window.addEventListener("scroll", () => {
      this.$bus.$emit("windowScroll", window.scrollY);
    });

    window.addEventListener("resize", () => {
      console.log("windowResize");
      this.$bus.$emit("windowResize");
    });
  },
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
</style>
